import { useCookies } from 'react-cookie'
import Config from '../../Config'

const useToken = () => {
  const [cookies] = useCookies([Config.cookie.name])
  return cookies && cookies[Config.cookie.name]
}

export default useToken
